export enum FileTypeEnum {
  EULA = 1,
  Invoice = 2,
  ImportQuote = 3,
  ImageQuote = 4,
  ImagePart = 5,
  Inventory = 6,
  Video = 7,
  ChangeStatusFile = 8,
  ReportTemplate = 9,
  EULAClaims = 10,
  Announcement = 11,
  CodeOfEthics = 12,
  ConflictOfInterest = 13,
  PrivacyNotice = 14,
  CodeOfEthicsClaims = 15,
  ConflictOfInterestClaims = 16,
  PrivacyNoticeClaims = 17,
  ImportBodyshopRates = 18
}